/**
 * The project's email address, under its name in the shell's sidebar: mail
 * to it reaches the project's lead (`api/project-email.ts`). A click copies it.
 */
import { Check, Mail } from "lucide-react";
import { useState } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function ProjectEmailAddress({ address }: { address: string }) {
  const [copied, setCopied] = useState(false);
  const copy = () =>
    void navigator.clipboard.writeText(address).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={copy}
            className="flex w-full min-w-0 items-center gap-1.5 rounded-md px-1 py-0.5 text-[11px] text-muted-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
          >
            {copied ? (
              <Check className="h-3.5 w-3.5 shrink-0" />
            ) : (
              <Mail className="h-3.5 w-3.5 shrink-0" />
            )}
            <span className="truncate">{address}</span>
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          {copied
            ? "Copied"
            : "Email the project lead here. Attachments are welcome."}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
